import { DataFilter } from '@siclop/kstone-vue'

export class WorkScheduleTemplateFilter extends DataFilter {
  code?: string
  label?: string

  constructor(data?: Partial<WorkScheduleTemplateFilter>) {
    super(data)
    if (data) {
      this.code = data.code
      this.label = data.label
    }
  }
}
